import React from "react";
import Grid from "../../GridCards/Grid";
const ComprasPadre = () => {
  return <Grid />;
};

export default ComprasPadre;
